export const MAXIMUM_DECLARED_VALUE = 90000000000000;
export const CONFIRMATION_DECLARED_VALUE = 750000000000000;
